<template>
<div>
  <input type="hidden" :name="`${formType}_definition`" :value="JSON.stringify(forms)">
  <input type="hidden" :name="`${formType}_button_definition`" :value="JSON.stringify(formButton)">
  <b-container fluid>
    <b-row cols="2">
      <b-col cols="9">
          <div class="wrapper--forms">
            <b-form>
              <b-row v-if="forms.length === 0">
                <div class="empty-section">Please add a new Section</div>
              </b-row>
              <b-row>
                <draggable :list="forms"
                class="dragArea"
                :group= "{ name:'formbuildersections', pull:'addSection', put:false }"
                :sort="true">
                  <template v-for="(formObj, formIndex) in forms">
                    <b-col :style="`margin-left:1%;width:${((formObj.span ? formObj.span : 12) / 12 * 100)-1}%; display: inline-block;`" :key="`div-${formIndex}`" class="section-block mb-4">
                      <div class="source">
                        <b-row>
                          <b-col cols="8">
                            <b-form-input @click="editSectionProperties(formObj)" class="nodrag" placeholder="Please input section title" v-model="formObj.title"></b-form-input>
                          </b-col>
                          <b-col cols="2">
                            <select class="nodrag" v-model="formObj.span" style="height: 35px; width: 100%">
                              <option value="3">Quarter width 3/12</option>
                              <option value="4">Third width 4/12</option>
                              <option value="6">Half width 6/12</option>
                              <option value="12">Full width 12/12</option>
                            </select>
                         <!--    <b-form-input class="nodrag" placeholder="Width"  v-model="formObj.span"></b-form-input> -->
                          </b-col>
                          <b-col cols="1">
                            {{ conditionIndicatorForField(formObj) }}
                          </b-col>
                          <b-col cols="1">
                            <b-button variant="outline-danger" size="sm" pill style="float: right" @click="deleteSection(formIndex, formObj.title)"><i class="la la-trash"></i></b-button>
                          </b-col>
                        </b-row>
                      </div>
                      <div class="meta">
                        <draggable :id="formObj.tagName"
                        :list="formObj.fields" class="dragArea" :group="{ name:'formbuilder', pull:false, put:true }" :sort="true" ghost-class="sortable__ghost">
                          <!-- The form elements starts (on the right) -->
                          <!-- <div> -->
                          <b-col :style="`width:${field.span / 12 * 100}%; display: inline-block`" v-for="(field, index) in formObj.fields" :key="index" v-bind="field" :span="field.span" class="form__group" :class="{ 'is--active': field === activeField }">
                            <span class="form__selectedlabel">{{ field.fieldType }} - {{ field.tagname }}</span>

                            <div @click="editElementProperties(field, formObj.tagName)">
                              <label for="" v-if="field.label && field.fieldType !== 'Flag'">{{ field.label }} {{ field.isRequired ? '*' : '' }} {{ conditionIndicatorForField(field) }}</label>
                                <i class="la la-info-circle" style="font-weight: bold; cursor: pointer"  aria-hidden="true" v-show="field.isTooltipVisible" data-toggle="tooltip" data-placement="right" :title="field.tooltipText"></i>
                              <component :is="field.fieldType" :currentField="field" class="form__field"></component>
                              <b-form-text style="font-size: 13px; font-style: italic" v-show="field.isHelpBlockVisible" v-text="field.helpBlockText"></b-form-text>
                            </div>

                            <!-- Actions list -->
                            <div class="form__actiongroup">
                              <b-button-group class="form__actionlist">
                                <b-button round variant="outline-info" size="sm" class="mr-1">
                                  <b-icon icon="arrows-move" class="rounded p-0"></b-icon>
                                </b-button>
                                <b-button size="sm" variant="outline-danger" @click="deleteElement(index, formObj.fields)">
                                  <b-icon icon="trash" class="rounded p-0"></b-icon>
                                </b-button>
                              </b-button-group>
                            </div>
                          </b-col>
                          <!-- </div> -->
                        </draggable>
                      </div>
                    </b-col>
                  </template>
                </draggable>
              </b-row>
            </b-form>
          </div>
      </b-col>
      <b-col cols="3" id="main-content">
        <div id="sidebar">
          <div class="sidebar__inner">
          <b-tabs card>
            <b-tab title="Sections" name="templated_sections" :active="activeTabForFields === 'templated_sections' "@click="reStick('templated_sections')" >
              <templated-sections :addSection="addSection" :selectSection="selectSection"/>
            </b-tab>

            <b-tab title="Fields" name="templated_fields" :active="activeTabForFields === 'templated_fields'" @click="reStick('templated_fields')" >
              <span><small><em>These fields have not been used yet in this form</em></small></span>
              <br>
              <br>
              <templated-fields />
            </b-tab>

            <!-- <b-tab title="Elements" name="elements" :active="activeTabForFields === 'elements'">
              <elements />
            </b-tab> -->

            <b-tab @click="reStick('properties')" title="Properties" name="properties" :active="activeTabForFields === 'properties'" v-if="(Object.keys(activeField).length > 0) || editingSection">
              <properties v-show="(Object.keys($store.activeField).length > 0) || editingSection"></properties>
            </b-tab>

          </b-tabs>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import {
  FormBuilder
} from '@/components/bs/formbuilder';
import draggable from 'vuedraggable';

export default {
  name: 'Home',
  props: ['formType'],
  store: ['forms', 'activeField', 'activeTabForFields', 'activeSectionTagName', 'conditioners', 'editingSection', 'formButton'],
  data() {
    return {
      sortElementOptions: FormBuilder.$data.sortElementOptions
    };
  },
  mounted() {
    setTimeout(() => {
      this.stickySidebar()
    }, 4000)
  },
  components: {
    ...FormBuilder.$options.components,
    draggable
  },
  methods: {

    conditionIndicatorForField(field) {
      var indicators = [];

      if(field.conditions.visibility && field.conditions.visibility.length) {
        indicators.push('V');
      }

      if(field.conditions.requirement && field.conditions.requirement.length) {
        indicators.push('R');
      }

      if(indicators.length) {
        return `(${ indicators.join(',') })`
      }

      return ''
    },

    reStick (tab) {
      this.activeTabForFields = tab
      this.stickySidebar().updateSticky()
    },

    stickySidebar() {
      return new StickySidebar('#sidebar', {
          containerSelector: '#main-content',
          innerWrapperSelector: '.sidebar__inner',
          topSpacing: 30,
          bottomSpacing: 30
      });
    },

    deleteElement(index, form) {
      FormBuilder.deleteElement(index, form, this.$parent)
    },
    editElementProperties(field, sectionTagName) {
      this.reStick('properties')
      FormBuilder.editElementProperties(field, sectionTagName, this.$parent)
    },
    editSectionProperties(section) {
      FormBuilder.editSectionProperties(section, this.$parent)
    },

    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    selectSection(section) {
      this.$parent.$store.activeSectionTagName = section.tagName
      this.$parent.$store.activeTabForFields = 'templated_fields'
    },

    addSection(formObj) {
      if(!formObj) {
        newFormObject = {
          title: "",
          conditions: {
            visibility: [],
            visibility_operand: 'AND'
          },
          fields: []
        };
      } else {

        if(!formObj.conditions) {
          formObj['conditions'] = {
            visibility: [],
            visibility_operand: 'AND'
          }
        }

        var newFormObject = _.cloneDeep(formObj);
        newFormObject.fields.forEach(field => {
          field.id = this.uuidv4()
          field.span = 12
          return field
        })
      }

      if(! newFormObject.id) {
        newFormObject.id = this.uuidv4()
      }

      this.forms.push(newFormObject);
    },

    deleteSection(formIndex, formTitle) {
      if(confirm('Are you sure?')) {
        this.$delete(this.forms, formIndex);
      }
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.empty-section {
  text-align: center;
  font-size: 20px;
  color: #ccc;
}

.dragArea {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    min-height: 150px;
    // height: calc(30vh);
    z-index: 2;
}

.el-main-left {
  height: calc(90vh);
}

.form__selectedlabel {
    display: none;
    background: #ECF5FF;
    padding: 3px 5px;
    color: black;
    font-size: 10px;
    position: absolute;
    top: -17px;
    right: 15px;
}

.form__actionitem--move {
    position: absolute;
    right: -14px;
    top: 50%;
    transform: translateY(-50%);
    visibility: hidden;

    &:active,
    &:focus,
    &:hover {
        border-color: #409EFF;
        background: #ECF5FF;
    }
}

.form__actionlist {
    position: absolute;
    margin-top: 10px;
    visibility: hidden;
    z-index: 3;
    right: 0;
    border-radius: 2px;
}

.form__group {
    margin-bottom: 25px;
    border: 1px solid transparent;
    position: relative;

    &:hover {
        // border-color: #409EFF;

        .form__actionitem--move {
            visibility: visible;
        }
    }

    &.is--active {
        border-color: #409EFF;
        background: #ECF5FF;

        .form__actionlist {
            visibility: visible;
        }
        .form__selectedlabel {
            display: inline-block;
        }
    }
}

.section-block {
    border: 1px solid #ebebeb;
    border-radius: 3px;
}

.section-block .source {
    padding: 10px
}

.section-block .meta {
    background-color: #fafafa;
    border-top: 1px solid #eaeefb;
}

</style>
